<template>
    <div class="nav">
      <!-- :class="[scrollval === 0 ? 'nav__top': 'nav__scrolled',opennav &&  scrollval === 0? 'open': '']" -->
      <div class="nav__inner">
        <div class="nav__logo">
          <a :href="inapp ? '#' : '/'"><img src="/img/logo.png" alt="HealthNow"></a>
          <div class="homenav__icon" :class="opennav ? 'open': ''" @click="opennav = !opennav" v-on:click="emitToParent">
              <span></span>
              <span></span>
              <span></span>
            </div>
        </div>
        <v-expand-transition>
          <div class="nav__link" v-show="opennav">
            <a href="/" class="recipient active">{{ $recipient }}</a>
            <a :href="$doctorlink" class="providers" target="_blank">{{ $providers }}</a>
          </div>
        </v-expand-transition>
      </div>
    </div>
</template>
<script>
export default {
  props: ['scrollcount'],
  data() {
    return {
      scrolled: true,
      scrollval: 0,
      opennav: false,
      inapp: false,
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.inapp = true;
    }
  },
  methods: {
    emitToParent(event) {
      this.$emit('childToParent', this.opennav);
    },
  },
  watch: {
    scrollcount(val) { // watch it
      this.scrollval = val;
    },
  },
};
</script>
